import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './alarmUpdates.scss';
import { AlarmHeader } from '../../assets/icons';
import { Divider, Grid, Menu } from '@mui/material';
import AlarmData from './alarmData/alarmData';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	alarmsNotificationDisableUpdate,
	criticalActiveAlarms,
	majorActiveAlarms,
	minorActiveAlarms,
} from '../../actions/maintenance/activeAlarmsActions';
import CustomCheckbox from '../checkbox/Checkbox';
import PropTypes from 'prop-types';
import Label from '../label/Label';
import useTheme from '../../hooks/useTheme';
import { getCookie, setCookie } from '../../utils/cookieHelper';
import { decryptBoolean,encryptData } from '../../utils/crypto';
import { ALARM_SUMMARY_VIEW_ALL_TRIGGER } from '../../constants/accessPointConstants';

const AlarmUpdate = ({fill, setHideTooltip}) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [criticalCount, setCriticalCount] = useState('');
	const [majorCount, setMajorCount] = useState('');
	const [minorCount, setMinorCount] = useState('');
	const { color } = useTheme('LIGHT');
	const tourStep = useSelector((state) => state.tourGuideStep.tourStep);
	const alarmIconRef = useRef(null);

	console.log('Critical Stared', anchorEl);
	const dispatch = useDispatch();
	const {t} = useTranslation()

	const activeAlarmListCritical = useSelector(
		(state) => state.activeAlarmsCriticalReducer
	);

	useEffect(() => {
		if (tourStep === 5 && alarmIconRef.current) {
			setAnchorEl(alarmIconRef.current);
			setHideTooltip(true);
		} else {
			setAnchorEl(null);
			setHideTooltip(false);
		}
	}, [tourStep]);


	useEffect(() => {
		if(anchorEl !== null){
			dispatch(criticalActiveAlarms(5,{"severity":"1"}));
		}
	}, [anchorEl]);

	console.log('CritiacalsdfsdData', activeAlarmListCritical?.activeAlarmsCritical?.count);
	const activeAlarmCritical = activeAlarmListCritical.activeAlarmsCritical
		.results
		? activeAlarmListCritical.activeAlarmsCritical.results
				.map((val) => {
					return {
						key: val.alarm_id,
						value: val.alarm_description ? val.alarm_description : '-',
					};
				})
		: [];

	const activeAlarmListMajor = useSelector(
		(state) => state.activeAlarmsMajorReducer
	);

	useEffect(() => {
		if(anchorEl !== null){
			dispatch(majorActiveAlarms(5,{"severity":"2"}));
		}
	}, [anchorEl]);

	console.log('Major Data', activeAlarmListMajor);
	const activeAlarmMajor = activeAlarmListMajor.activeAlarmsMajor.results
		? activeAlarmListMajor.activeAlarmsMajor.results
				.map((val) => {
					return {
						key: val.alarm_id,
						value: val.alarm_description ? val.alarm_description : '-',
					};
				})
		: [];

	const activeAlarmListMinor = useSelector(
		(state) => state.activeAlarmsMinorReducer
	);

	useEffect(() => {
		if(anchorEl !== null){
			dispatch(minorActiveAlarms(5,{"severity":"3"}));
		}
	}, [anchorEl]);

	console.log('Minor Data', activeAlarmListMinor);
	const activeAlarmMinor = activeAlarmListMinor.activeAlarmsMinor.results
		? activeAlarmListMinor.activeAlarmsMinor.results
				.map((val) => {
					return {
						key: val.alarm_id,
						value: val.alarm_description ? val.alarm_description : '-',
					};
				})
		: [];

	useEffect(()=>{
		if(activeAlarmListCritical){
			setCriticalCount(activeAlarmListCritical?.activeAlarmsCritical?.count || '0')
		}
		if(activeAlarmListMajor){
			setMajorCount(activeAlarmListMajor?.activeAlarmsMajor?.count || '0')
		}
		if(activeAlarmListMinor){
			setMinorCount(activeAlarmListMinor?.activeAlarmsMinor?.count || '0')
		}
	},[activeAlarmListCritical,activeAlarmListMajor,activeAlarmListMinor])

	const navigate = useNavigate();
	const handleView = () => {
		navigate('/maintenance');
		dispatch({ type: ALARM_SUMMARY_VIEW_ALL_TRIGGER, payload: true });
		handleClose();
	};

	const checkValue = decryptBoolean(getCookie('dnd_enable'));

	const [checked, setChecked] = useState(null);
	useEffect(()=>{
		if(checkValue === true){
		setChecked(true);
		}else{
			setChecked(false);
		}
	},[checkValue])
	// console.log('dndEnable:',getCookie('dnd_enable'))
	const handleCheckbox = () => {
		setChecked(!checked);
		if(checked){
			dispatch(alarmsNotificationDisableUpdate({"dnd_enable":1}))
			setCookie({name:'dnd_enable',value:encryptData(String(false))})
		}else if(!checked){
			dispatch(alarmsNotificationDisableUpdate({"dnd_enable":0}))
			setCookie({name:'dnd_enable',value:encryptData(String(true))})
		}

	};

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
		setHideTooltip(true);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setHideTooltip(false);
		
	};

	// useEffect(()=>{
	// 	if(checked === true){
	// 		console.log('Cliked1')
	// 	}else if(checked === false){
	// 		console.log('Cliked2')
	// 	}
	// },[checked])

	return (
		<>
			<AlarmHeader ref={alarmIconRef} fill={fill} onClick={handleClick} />
			<Menu
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{
					marginTop: '15px',
					zIndex: tourStep === 5 ? 13000 : '',
					pointerEvents: tourStep === 5 ? 'none' : '',
					overflow: tourStep === 5 ? 'hidden' : '',
				}}
				PaperProps={{
					sx: {
						border: tourStep === 5 ? '2px solid #500d76' : 'none',
						borderRadius: tourStep === 5 ? '0px' : '4px',
					},
				}}
			>
				<Grid>
					<Grid
						sx={{
							width: '426px',
							height: '41px',
							display: 'flex',
							justifyContent: 'space-between',
							marginBottom: '-8px',
						}}
					>
						<div
							style={{
								marginLeft: '12px',
								marginTop: '1px',
								height: '22px',
							}}
						>
							<Label
								type={'primary'}
								label={t('Alarms Summary')}
								fontFamily={'Inter-Bold'}
								fontSize={'input_text'}
							/>
						</div>
						<div style={{ display: 'flex', marginTop: '4px' }}>
							<span
								className="display-header"
								style={{ width: '190px' }}
							>
								<Label
									type={'secondary'}
									label={t('Display alarms alerts on screen')}
									fontFamily={'Inter-Regular'}
									fontSize={'xx_small'}
								/>
							</span>
							<div
								style={{
									marginRight: '13px',
									paddingLeft: '4px',
									marginTop: '2px',
								}}
							>
								<CustomCheckbox
									sx={{ width: '14px', height: '14px' }}
									checked={checked}
									onChecked={handleCheckbox}
								/>
							</div>
						</div>
					</Grid>
					<Divider
						className="alarm-divider"
						sx={{
							height: '1px',
							backgroundColor: color.stroke.light,
						}}
					/>
					<Grid
						sx={{
							display: 'flex',
							width: '100%',
						}}
					>
						<AlarmData
							activeAlarmCritical={activeAlarmCritical}
							activeAlarmMajor={activeAlarmMajor}
							activeAlarmMinor={activeAlarmMinor}
							criticalCount={criticalCount}
							majorCount={majorCount}
							minorCount={minorCount}
						/>
					</Grid>
					<Grid className="view-Alarms" onClick={handleView}>
						<Label
							type={'hyperlink'}
							label={t('View All Alarms')}
							fontFamily={'Inter-SemiBold'}
							fontSize={'xx_inputlabel'}
							style={{ cursor: 'pointer' }}
						/>
					</Grid>
				</Grid>
			</Menu>
		</>
	);
};

export default AlarmUpdate;

AlarmUpdate.propTypes = {
	fill: PropTypes.string,
	setHideTooltip: PropTypes.func,
};
